import _ from "lodash";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { Fragment } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import FormButton from "../../components/form/FormButton";
import FormTextField from "../../components/form/FormTextField";
import InspectorAttachmentList from "../../components/inspector/InspectorAttachmentList";
import InspectorAttachmentPopover from "../../components/inspector/InspectorAttachmentPopover";
import InspectorField from "../../components/inspector/InspectorField";
import InspectorGroup from "../../components/inspector/InspectorGroup";
import InspectorImageWell from "../../components/inspector/InspectorImageWell";
import InspectorRow from "../../components/inspector/InspectorRow";
import pubSubTopics from "../../constants/pubSubTopics";
import urlPrefixes from "../../constants/urlPrefixes";
import { attachmentSelectors } from "../../modules/attachments";
import batchOperations from "../../modules/batchOperations";
import { itemOperations } from "../../modules/items";
import { uiStateOperations } from "../../modules/uiState";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { PropTypeShapes } from "../../types";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import { getLabelWithUntitled } from "../../utils/labelUtils";
import openUrl from "../../utils/openUrl";
import uniqueId from "../../utils/uniqueId";

const displayStringForLinkUrl = url => {
  let result = url;
  if (url.indexOf(urlPrefixes.RELATIVE_PREFIX) == 0) {
    // Starts with relative path
    const path = atob(url.substr(urlPrefixes.RELATIVE_PREFIX.length));
    // And remove last path component, which is the filename
    result = path.substr(0, path.lastIndexOf("/"));
    if (!result.length) {
      result = "./";
    }
  } else if (url.indexOf(urlPrefixes.LOCAL_PREFIX) == 0) {
    // Local path... just remove protocol
    const path = url.substr(urlPrefixes.LOCAL_PREFIX.length);
    result = path.substr(0, path.lastIndexOf("/"));
  }
  return result;
};

class InspectorAttachmentsTab extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onAddAttachment = this.onAddAttachment.bind(this);
    this.onAddImage = this.onAddImage.bind(this);
    this.onLinkClick = this.onLinkClick.bind(this);
    this.onAttachmentClick = this.onAttachmentClick.bind(this);
    this.onBrowseForLink = this.onBrowseForLink.bind(this);
    this.onBrowseForImage = this.onBrowseForImage.bind(this);
    this.openPopover = this.openPopover.bind(this);
    this.closePopover = this.closePopover.bind(this);
    this.addNewLink = this.addNewLink.bind(this);
    this.setNewImage = this.setNewImage.bind(this);
    this.getAttachmentOptions = this.getAttachmentOptions.bind(this);
    this.getSelectedAttachments = this.getSelectedAttachments.bind(this);
    this.getSelectedLinks = this.getSelectedLinks.bind(this);
    this.getSelectedImage = this.getSelectedImage.bind(this);

    //#!if iOS === true
// this.onAddImageFromPhotos = this.onAddImageFromPhotos.bind(this);
    //#!endif

    this.state = {
      popoverOpen: false
    };
  }

  getAttachmentOptions = () =>
    this.props.attachments.toList().map(a => ({
      label: a.label,
      value: a.id
    }));

  getSelectedAttachments = () =>
    this.props.itemData.attachments.map(id => {
      const attachment = this.props.attachments.get(id);
      return {
        id,
        label: attachment.label ? attachment.label : null
      };
    });

  getSelectedLinks = () =>
    this.props.itemData.links.map(id => ({
      id,
      label: this.props.attachments.get(id).label,
      url: displayStringForLinkUrl(this.props.attachments.get(id).path)
    }));

  getSelectedImage = () =>
    !_.isNil(this.props.itemData.image) ? this.props.attachments.get(this.props.itemData.image) : null;

  onAddAttachment = () => {
    PubSub.publish(pubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.BROWSE_TO_ADD_ATTACHMENT,
      attachmentId: uniqueId()
    });
  };

  onBrowseForLink = () => {
    PubSub.publish(pubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.BROWSE_TO_ADD_LINK
    });
  };

  onBrowseForImage = () => {
    PubSub.publish(pubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.BROWSE_TO_ADD_IMAGE_LINK
    });
  };

  onAddImage = () => {
    PubSub.publish(pubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.BROWSE_TO_ADD_IMAGE,
      attachmentId: uniqueId()
    });
  };

  //#!if iOS === true
// onAddImageFromPhotos = () => {
// PubSub.publish(pubSubTopics.sendNativeMessage, {
// msg: nativeCommsBroadcastMessageTypes.BROWSE_TO_ADD_IMAGE_FROM_PHOTOS,
// attachmentId: uniqueId()
// });
// };
  //#!endif

  openPopover = () => {
    this.setState({ popoverOpen: true });
    this.props.onSetHasChildPopover(true);
  };

  closePopover = () => {
    this.setState({ popoverOpen: false });
    this.props.onSetHasChildPopover(false);
  };

  addNewLink = (url, title) => {
    this.props.onAddNewLink(this.props.itemIds, title, url);
  };

  setNewImage = (url, title) => {
    this.props.onSetNewImage(this.props.itemIds, title, url);
  };

  onLinkClick = id => {
    const path = this.props.attachments.get(id).path;
    openUrl(path);
  };

  onAttachmentClick = attachmentId => {
    PubSub.publish(pubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.OPEN_ATTACHMENT,
      attachmentId
    });
  };

  onImageClick = attachmentId => {
    PubSub.publish(pubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.OPEN_ATTACHMENT,
      attachmentId
    });
  };

  render() {
    const selectedImage = this.getSelectedImage();

    let showBrowse = true;
    //#!if iOS === true
// showBrowse = false;
    //#!end
// 
    let imageButtons = null;
    //#!if iOS === true
// imageButtons = [
// <FormButton key="BrowseDocuments" label="Browse Documents" linkStyle={true} onClick={this.onAddImage} />,
// <FormButton key="BrowsePhotos" label="Browse Photos" linkStyle={true} onClick={this.onAddImageFromPhotos} />
// ];
    //#!else
    imageButtons = [
      <FormButton key="attachImage" label="Attach image" linkStyle={true} onClick={this.onAddImage} />,
      <FormButton
        key="addFromURL"
        className="addFromURL"
        id="addFromURL"
        label="Link to image"
        linkStyle={true}
        onClick={this.openPopover}
      />,
      <InspectorAttachmentPopover
        key="addFromURLPopover"
        target={"addFromURL"}
        visible={this.state.popoverOpen}
        showBrowse={showBrowse}
        onAddClick={this.setNewImage}
        onBrowseClick={this.onBrowseForImage}
        toggle={this.closePopover}
      />
    ];
    //#!endif

    return (
      <Fragment>
        <InspectorGroup label="Image">
          {selectedImage ? (
            <InspectorRow>
              <InspectorImageWell
                source={selectedImage.path}
                onDelete={() => this.props.onRemoveImage(this.props.itemIds, this.props.itemData.image)}
                onView={() => this.onImageClick(this.props.itemData.image)}
              />
            </InspectorRow>
          ) : (
            <InspectorRow>
              <InspectorField className="inspectorRightAligned">{imageButtons}</InspectorField>
            </InspectorRow>
          )}
        </InspectorGroup>
        <InspectorGroup label="Files">
          <InspectorRow label="Attachments">
            <InspectorField>
              <InspectorAttachmentList
                id={"attachments"}
                onAddNew={this.onAddAttachment}
                onRemove={id => this.props.onRemoveAttachment(this.props.itemIds, id)}
                onItemClick={this.onAttachmentClick}
                values={this.getSelectedAttachments()}
                itemIds={this.props.itemIds}
                title="Add Attachment"
                backText={getLabelWithUntitled(this.props.itemData.label)}
                onTogglePopover={this.props.onSetHasChildPopover}
              />
            </InspectorField>
          </InspectorRow>
          <InspectorRow label="Links">
            <InspectorField>
              <InspectorAttachmentList
                id={"links"}
                values={this.getSelectedLinks()}
                onRemove={id => this.props.onRemoveLink(this.props.itemIds, id)}
                onAddNew={this.addNewLink}
                onItemClick={this.onLinkClick}
                onBrowseClick={this.onBrowseForLink}
                showBrowse={showBrowse}
                popover={true}
                showUrls={true}
                title="Add Link"
                backText={getLabelWithUntitled(this.props.itemData.label)}
                onTogglePopover={this.props.onSetHasChildPopover}
              />
            </InspectorField>
          </InspectorRow>
        </InspectorGroup>
        {this.props.typeData.canHaveLocationUri ? (
          <InspectorGroup label="Location">
            <InspectorRow label="Location URI">
              <InspectorField>
                <FormTextField
                  multiline={false}
                  value={this.props.itemData.locationUri}
                  onChange={value => this.props.onEditLocationUri(this.props.itemIds, value)}
                />
              </InspectorField>
            </InspectorRow>
          </InspectorGroup>
        ) : null}
      </Fragment>
    );
  }
}

InspectorAttachmentsTab.propTypes = {
  onSetNewImage: PropTypes.func.isRequired,
  onAddNewAttachment: PropTypes.func.isRequired,
  onAddNewLink: PropTypes.func.isRequired,
  onRemoveImage: PropTypes.func.isRequired,
  onRemoveAttachment: PropTypes.func.isRequired,
  onRemoveLink: PropTypes.func.isRequired,
  onEditLocationUri: PropTypes.func.isRequired,
  attachments: ImmutablePropTypes.map,
  itemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  itemData: PropTypeShapes.inspectorItem,
  typeData: PropTypeShapes.denormalisedTypeDefinition,
  onSetHasChildPopover: PropTypes.func
};

const mapStateToProps = state => {
  return {
    attachments: attachmentSelectors.getAttachmentsById(state.present)
  };
};

const readonlyActions = {};

const editingActions = {
  onSetNewImage: batchOperations.createAttachmentAndAssignToItemsImages,
  onAddNewAttachment: batchOperations.createAttachmentAndAssignToItemsAttachments,
  onAddNewLink: batchOperations.createAttachmentAndAssignToItemsLinks,
  onRemoveImage: itemOperations.clearImage,
  onRemoveAttachment: itemOperations.removeAttachment,
  onRemoveLink: itemOperations.removeLink,
  onEditLocationUri: itemOperations.editLocationUri,
  onSetHasChildPopover: uiStateOperations.setLeftPanelHasChildPopover
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InspectorAttachmentsTab);
